import { render, staticRenderFns } from "./pabx.vue?vue&type=template&id=6aa706d8&"
import script from "./pabx.vue?vue&type=script&lang=js&"
export * from "./pabx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports